/**
 * Convert numbers, numeric strings, or bigints into a finite number or undefined.
 */
export function toFiniteNumber(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'bigint') {
    const converted = Number(value);
    return Number.isFinite(converted) ? converted : undefined;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      return;
    }
    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return;
}

export const toNumberOrUndefined = toFiniteNumber;

/**
 * Parse positive integers from a variety of numeric inputs, clamping negatives to zero.
 */
export function toPositiveInteger(value: unknown): number | undefined {
  const parsed = toFiniteNumber(value);
  if (parsed === undefined) {
    return;
  }
  if (parsed < 0) {
    return 0;
  }
  return Math.trunc(parsed);
}

/**
 * Extract finite number or return zero fallback.
 * Useful for optional numeric fields that should default to 0.
 *
 * @example
 * const count = toFiniteNumberOrZero(tweet.likeCount);  // number | null -> number
 */
export function toFiniteNumberOrZero(value: number | null | undefined): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}
